export default "__VITE_ASSET__524a052b__"